module.exports = __webpack_public_path__ + "img/symbol_7.e0f19648.png";